import { notify } from 'utils/reduxUtils';

export const types = {
  INIT: 'processes/customInterrogations/listPage/INIT',
  CREATE_CUSTOM_INTERROGATION_REQUEST:
    'processes/customInterrogations/listPage/CREATE_CUSTOM_INTERROGATION_REQUEST',
  CREATE_CUSTOM_INTERROGATION_SUCCESS:
    'processes/customInterrogations/listPage/CREATE_CUSTOM_INTERROGATION_SUCCESS',
  CREATE_CUSTOM_INTERROGATION_ERROR:
    'processes/customInterrogations/listPage/CREATE_CUSTOM_INTERROGATION_ERROR',
  CREATE_MODAL_OPEN:
    'processes/customInterrogations/listPage/CREATE_MODAL_OPEN',
  CREATE_MODAL_CLOSE:
    'processes/customInterrogations/listPage/CREATE_MODAL_CLOSE',
};

export const init = ({ customInterrogations }) => ({
  type: types.INIT,
  payload: { customInterrogations },
});

export const create = {
  request: ({ name, task }) => ({
    type: types.CREATE_CUSTOM_INTERROGATION_REQUEST,
    payload: { name, task },
  }),
  success: ({ customInterrogation }) => ({
    type: types.CREATE_CUSTOM_INTERROGATION_SUCCESS,
    payload: { customInterrogation },
  }),
  error: notify(
    (error) => ({
      type: types.CREATE_CUSTOM_INTERROGATION_ERROR,
      payload: error,
    }),
    'Failed to create Custom Interrogation',
  ),
};

export const createModal = {
  open: () => ({
    type: types.CREATE_MODAL_OPEN,
  }),
  close: () => ({
    type: types.CREATE_MODAL_CLOSE,
  }),
};
